import { useState } from 'react';

import {
  ChakraAvatar,
  ChakraBox,
  ChakraFlex,
  ChakraText,
  ChatUser,
  EquipUITheme,
  Popover,
} from '@equip.health/ui';
import { getProviderDisplayName } from '~/lib/util/chat/chatChannel.util';

const idPrefix = 'avatar';
const idPostfix = 'popover';

const { h6, paragraph } = EquipUITheme.typography;
interface AvatarPopoverViewProps {
  id: string;
  noStyles?: boolean;
  size?: string;
  user: ChatUser;
}

const AvatarPopoverView = ({
  id,
  noStyles = false,
  size = 'md',
  user,
}: AvatarPopoverViewProps) => {
  const [showUserPopover, setShowUserPopover] = useState<boolean>(false);

  const avatarProps = {
    background: 'tertiary.marigold.background',
    borderColor: 'neutral.line',
    borderWidth: noStyles ? '1px' : '4px',
    color: 'black',
    cursor: 'default',
    id: `avatar_${id}__member`,
    name: user?.nickname,
    onMouseLeave: () => setShowUserPopover(false),
    onMouseMove: () => setShowUserPopover(true),
    showBorder: true,
    size: noStyles ? size : null,
  };

  return (
    <Popover
      bodyContent={
        <ChakraFlex
          alignItems="center"
          id={`${idPrefix}-avatar-wrapper__${id}__${idPostfix}`}
        >
          <ChakraAvatar
            background="tertiary.marigold.background"
            borderColor="neutral.primary"
            borderWidth="4px"
            color="black"
            data-testid={`${idPrefix}-avatar__${id}__${idPostfix}`}
            id={`${idPrefix}-avatar__${id}__${idPostfix}`}
            name={user?.nickname}
            showBorder
          />
          <ChakraBox paddingLeft="12px">
            <ChakraText
              color="neutral.primary"
              {...h6}
              data-testid={`${idPrefix}-nickname__${id}__${idPostfix}`}
              id={`${idPrefix}-nickname__${id}__${idPostfix}`}
            >
              {user?.nickname}
            </ChakraText>
            <ChakraText
              color="neutral.secondary"
              data-testid={`${idPrefix}-provider-type__${id}__${idPostfix}`}
              id={`${idPrefix}-provider-type__${id}__${idPostfix}`}
              {...paragraph}
              lineHeight="16.8px"
            >
              {getProviderDisplayName(user?.metaData?.providerType)}
            </ChakraText>
          </ChakraBox>
        </ChakraFlex>
      }
      id={`${idPrefix}-popover-wrapper__${id}__${idPostfix}`}
      isOpen={showUserPopover}
      margin="25px 0px 0px -25px"
      placement="right-start"
      triggerContent={
        <ChakraAvatar
          {...avatarProps}
          {...h6}
          id={`${idPrefix}-popover-trigger__${id}__${idPostfix}`}
        />
      }
    />
  );
};

export default AvatarPopoverView;
